export default __webpack_public_path__ + "static/media/ScanCode.da905032.svg";